import { render, staticRenderFns } from "./InputBankDetails.vue?vue&type=template&id=19b1a55a&"
import script from "./InputBankDetails.vue?vue&type=script&lang=js&"
export * from "./InputBankDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports